import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, Redirect } from 'react-router-dom'
import moment from 'moment';
import { Modal } from "react-bootstrap";
import { Pagination, Tooltip } from 'antd';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import Select from 'react-select';

import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js";
import { useTheme } from "./theme-provider.js"
import PageError from '../common_component/PageError.js';
import TableColumnHead from "../common_component/TableColumnHead.js";
import StatusBadge from "../common_component/StatusBadge.js";
import { useModal } from '../providers/modal-provider.js';

const CustomerDeliveryChallanList = () => {
    const { openModal, setModalView, setModalData } = useModal();
    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme()
    const [timezone_change, set_timezone_change] = useState("+00:00");

    const [deliveryChallanList, setDeliveryChallanList] = useState([])
    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [sortColumn, setSortColumn] = useState(null)
    const [sortValue, setSortValue] = useState(null)
    const [searchValue, setSearchValue] = useState(null)
    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))
    const [deliveryChallanListApiState, setDeliveryChallanListApiState] = useState(false)

    const [warehouseProcessingList, setWarehouseProcessingList] = useState([])
    const [warehouseProcessingListApiState, setWarehouseProcessingListApiState] = useState(false)

    const [branchesList, setBranchesList] = useState([])
    const [warehouseList, setWarehouseList] = useState([])

    const [data, setData] = useState([]);

    const [itemsModalShow, setItemsModalShow] = useState(false)
    const [itemsData, setItemsData] = useState([])

    const [invoiceSelectionModalShow, setInvoiceSelectionModalShow] = useState(false)
    const [invoicesList, setInvoicesList] = useState([])
    const [selectedInvoice, setSelectedInvoice] = useState(null)

    const [submitButtonState, setSubmitButtonState] = useState(false)

    const daterange_picker_ref = useRef()

    var page_name = "customer-delivery-challan-list";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const handleOpenRevertModal = (obj) => {
        setModalData({
            customer_invoice_id: obj.customer_invoice_id,
            organization_id: obj.organization_id, // or your global organization_id variable
            page_name,
            apiCallback: (updatedInfo) => {
                // Refresh your table/list data here after successful revert
                getDeliveryChallanList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate);
                console.log("Successfully reverted, refreshing list...", updatedInfo);
                // fetchTableData();
            },
            modalCloseCallback: () => {
                console.log("Revert modal closed");
            }
        });
        setModalView("REVERT_MODAL");
        openModal();
    };

    async function getDeliveryChallanList(cp, rpp, sort_c, sort_v, search_v, sd, ed) {
        setDeliveryChallanListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-delivery-challan-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp - 1, "rows_per_page": rpp, "sort_column": sort_c, "sort_value": sort_v, "search_value": search_v, "start_date": sd, "end_date": ed, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation == "success") {
            setDeliveryChallanList(body.data.list);
            setListCount(body.data.count)

            setDeliveryChallanListApiState(false)
        }
        else {
            throw "basic customer delivery challan list api error"
        }
    }

    async function getBranches() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)
        if (body.operation == "success") {
            setBranchesList(body.data)
        }
    }

    async function getWarehouses() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/list-warehouse`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setWarehouseList(body.data)
        }
    }
    async function getWarehouseProcessingBySearch(val) {
        setWarehouseProcessingListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-warehouse-processing-by-search`, { method: 'POST', body: JSON.stringify({ search_value: val, "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        setWarehouseProcessingList(body.data)
        setWarehouseProcessingListApiState(false)
    }

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
                    const timezone = body.data[0].timezone_value;
                    set_timezone_change(timezone);
                }
            }
        }
        else {
            throw "timezone api error"
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getDeliveryChallanList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate);
            let p2 = getBranches();
            let p3 = getWarehouses();
            let p4 = getWarehouseProcessingBySearch("");
            let p5 = getTimezoneInformation();

            Promise.all([p1, p2, p3, p4, p5])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((errx) => {
                    console.log(errx)
                    setstate(3)
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getDeliveryChallanList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate)
        }
    }, [currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate])


    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Customer Delivery Challan List</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/sales/invoice/delivery_challan`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                        <button className="btn btn-sm btn-primary btn-hover-scale" data-kt-indicator={state !== 1 ? "on" : "off"} disabled={state !== 1} onClick={() => { setInvoiceSelectionModalShow(true) }}>
                            <span className="indicator-label">
                                <span className="d-md-none">
                                    <svg width="15" height="15" viewBox="0 0 11 11" fill="none">
                                        <path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff">
                                        </path>
                                    </svg>
                                </span>
                                <span className="d-none d-md-inline">Create New Challan</span>
                                {/* <i className="bi bi-plus-circle"></i>Create New Challan */}
                            </span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </div>
                <div>
                    {
                        state === 1 ?
                            <>
                                <div className="row gx-0 gap-5 m-2">
                                    <div className='col-md-3'>
                                        <DateRangePickerComponent
                                            ref={daterange_picker_ref}
                                            allowEdit={false}
                                            showClearButton={false}
                                            focus={() => { daterange_picker_ref.current.show() }}
                                            delayUpdate={true}
                                            presets={[
                                                { label: 'Today', start: new Date(), end: new Date() },
                                                { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                                { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                                { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                                            ]}
                                            change={(e) => {
                                                setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                            }}
                                            startDate={new Date(startDate)}
                                            endDate={new Date(endDate)}
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </div>
                                </div>
                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-body py-3">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>

                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            {
                                                deliveryChallanListApiState ?
                                                    <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                    :
                                                    deliveryChallanList.length > 0 && warehouseList.length > 0 && branchesList.length > 0 ?
                                                        <>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    showQuickJumper={true}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                />
                                                            </div>

                                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }}>
                                                                    <thead>
                                                                        <tr className="fw-bold text-muted">
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'invoice_date'} label={'Invoice Details'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'challan_number'} label={'Challan No.'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px">Branch - Warehouse</th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'customer_name'} label={'Customer Name'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'items'} label={'Product Details'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'warehouse_add_date_time'} label={'Warehouse Date and time'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-150px"><TableColumnHead columnKey={'add_date_time'} label={'Challan Date and time'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="text-end"><TableColumnHead columnKey={'add_status'} label={'Status'} {...{ sortColumn, setSortColumn, sortValue, setSortValue }} /></th>
                                                                            <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            deliveryChallanList.map((obj, indx) => {
                                                                                return (
                                                                                    <tr key={obj.delivery_challan_id}>
                                                                                        <td>
                                                                                            <span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.customer_invoice_number + " - " + moment(obj.invoice_date).format("ll")}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.delivery_challan_number}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span className="badge badge-light-info">{branchesList.find(x => x.branch_id === obj.branch_id).branch_name + " - " + warehouseList.find(x => x.wid === obj.warehouse_id).name}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.customer_name}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className='btn btn-sm btn-info rounded' onClick={() => { setItemsModalShow(true); setItemsData(obj.item_array) }}>View</button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj.add_date_time).utcOffset(timezone_change).format("lll")}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj.warehouse_add_date_time).utcOffset(timezone_change).format("lll")}</span>
                                                                                        </td>
                                                                                        <td className="text-end">
                                                                                            <StatusBadge status={obj.add_status} entity={"CUSTOMER_DELIVERY_CHALLAN"} />
                                                                                        </td>
                                                                                        <td className="sticky-column">
                                                                                            <div className="dropdown">
                                                                                                <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                                    <i className="fas fa-bars px-0"></i>
                                                                                                </button>
                                                                                                {
                                                                                                    (write && (user.email === "meadoerp@gmail.com" || user.email === "bumba3245@intelmetic.org")) &&
                                                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                        <li className="dropdown-item cursor-pointer" onClick={() => handleOpenRevertModal(obj)}>Revert Delivery Challan</li>
                                                                                                    </ul>
                                                                                                }
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <div className="mt-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="text-muted fs-2 my-auto text-center">No data to be shown</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state === 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                state == 3 ?
                                    <PageError>
                                        <div className="notice bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                            <h4 className="text-gray-800 fw-bolder">Create a new Customer Invoice</h4>
                                            <div className='mt-10 text-center'>
                                                <Link className='btn btn-primary rounded' to={`/create-customer-invoice`}>Create an Invoice</Link>
                                            </div>
                                        </div>
                                    </PageError>
                                    :
                                    <PageError>
                                        <div className="notice bg-light-danger rounded border-primary border border-dashed rounded-3 p-6">
                                            <h4 className="text-gray-800 fw-bolder">Something went wrong</h4>
                                            <div className='mt-10 text-center'>
                                                <button className='btn btn-primary rounded' onClick={() => { window.location.reload() }}>Reload the page</button>
                                            </div>
                                        </div>
                                    </PageError>
                    }

                </div>
            </div>

            <Modal show={itemsModalShow} onHide={() => { setItemsModalShow(false); setItemsData([]); }} centered>
                <Modal.Header>
                    <Modal.Title>Total Items: {itemsData.length}</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setItemsModalShow(false); setItemsData([]); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className='table-responsive'>
                            <table className='table table-striped table-hover'>
                                <thead className='bg-light-info fs-4 fw-bold text-primary'>
                                    <tr>
                                        <th scope='col'>Item Name</th>
                                        <th scope='col'>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        itemsData.map((obj, indx) => {
                                            return (
                                                <tr key={indx}>
                                                    <td className='fw-bold'>
                                                        <span className="bullet bg-primary me-2 rounded-circle" style={{ width: '10px', height: '10px', display: 'inline-block' }}></span>
                                                        {obj.item_name}
                                                    </td>
                                                    <td>{obj.quantity}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary rounded" onClick={() => { setItemsModalShow(false); setItemsData([]); }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={invoiceSelectionModalShow} onHide={() => { setInvoiceSelectionModalShow(false); }} centered>
                <Modal.Header>
                    <Modal.Title>Choose an Invoice to proceed</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setInvoiceSelectionModalShow(false); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <Select
                            options={warehouseProcessingList.map(x => { return { label: x.customer_invoice_number, value: x.warehouse_processing_id } })}
                            onChange={(val) => { setSelectedInvoice(val) }}
                            onInputChange={(val) => { getWarehouseProcessingBySearch(val) }}
                            value={selectedInvoice}
                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                            placeholder="Search for an Invoice"
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary rounded" onClick={() => { setInvoiceSelectionModalShow(false); }}>Close</button>
                    <button className="btn btn-success rounded" onClick={() => {
                        selectedInvoice == null ? swal("Alert", "Select an Invoice before proceeding", "warning")
                            : window.location.href = `/create-customer-delivery-challan/${selectedInvoice.value}`
                    }}
                    >Proceed</button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CustomerDeliveryChallanList;
